import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { PatientProgramApi } from '../../../apis/PatientProgramApi/PatientProgramApi.ts';
import { PatientProgram } from '../PatientProgram.ts';

export function useGetPatientProgram(patientId?: string) {
  return useQuery<PatientProgram | null>({
    queryKey: [QueryKeys.patientProgram, patientId],
    queryFn: () => PatientProgramApi.getPatientProgram(parseInt(patientId!, 10)),
    enabled: !!patientId,
  });
}
